import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
};

/** Describes the outcome of the available configs */
export type AvailableConfig = {
  __typename?: 'AvailableConfig';
  /** The display name for the config file */
  displayName: Scalars['String'];
  /** The config file name */
  originalFileName: Scalars['String'];
};

/** Describes the available config files */
export type AvailableConfigsResponse = {
  __typename?: 'AvailableConfigsResponse';
  /** Available Configs */
  availableConfigs?: Maybe<Array<Maybe<AvailableConfig>>>;
};

/** Describes a BEE */
export type Bee = {
  __typename?: 'Bee';
  /** Indicates if all peripheral healthchecks for a BEE passed */
  arePeripheralsHealthy?: Maybe<Scalars['Boolean']>;
  createdOn?: Maybe<Scalars['String']>;
  /** Indicates the current overall app version for a BEE */
  currentAppVersion?: Maybe<Scalars['String']>;
  /** The current firmware version */
  currentFirmwareVersion?: Maybe<Scalars['String']>;
  /** The device ID, a global identifier for the BEE which can be used to control a property. The device ID in which to control a property can change if the BEE hardware is replaced */
  deviceId?: Maybe<Scalars['String']>;
  /** A time when the last firmware update was requested */
  firmwareUpdateRequested?: Maybe<Scalars['DateTime']>;
  /** The last requested firmware version */
  firmwareUpdateVersion?: Maybe<Scalars['String']>;
  /** The current firmware version */
  firmwareVersion?: Maybe<Scalars['String']>;
  /** The hardware version */
  hardwareVersion?: Maybe<Scalars['String']>;
  /** Indicates whether a BEE is currently in an trial event */
  inActiveTrialEvent?: Maybe<Scalars['Boolean']>;
  /** The last updated perpherial healthcheck */
  isHealthy?: Maybe<Scalars['Boolean']>;
  /** Indicates if the heat source for the BEE is on or off */
  isHeatSourceOn?: Maybe<Scalars['Boolean']>;
  /** The property address the BEE lives at */
  physicalAddress?: Maybe<PropertyAddress>;
  /** Plot number BEE is installed in */
  plot?: Maybe<Scalars['String']>;
  /** Project the BEE is installed on */
  project?: Maybe<Scalars['String']>;
  /** The MAC address of the router connected to the BEE. This can change if the router hardware is changed. Mac address should be queried in lower case */
  routerId?: Maybe<Scalars['String']>;
  /** A time when the last state update was happened */
  stateLastUpdated?: Maybe<Scalars['DateTime']>;
  /** The current status of the BEE */
  status?: Maybe<Scalars['String']>;
  /** The sticker image associated to this BEE */
  stickerImage?: Maybe<Scalars['String']>;
  /** The tags associated to this BEE */
  tags?: Maybe<Array<BeeTag>>;
  /** The trial that the bee is currently participating in */
  trial?: Maybe<Trial>;
  /** The trial id that the bee is currently participating in */
  trialId?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
  /** Unique property reference number. If BEE hardware is replaced this will be the correlation between the BEE hardware and property */
  uprn?: Maybe<Scalars['String']>;
};

/** The shape of the rule object */
export type BeeConfigurationRule = {
  __typename?: 'BeeConfigurationRule';
  inputs?: Maybe<BeeConfigurationRuleInput>;
  metadata?: Maybe<BeeConfigurationRuleMetadata>;
  name?: Maybe<Scalars['String']>;
};

/** Describes the inputs for a rule */
export type BeeConfigurationRuleInput = {
  __typename?: 'BeeConfigurationRuleInput';
  /** The address of the peripheral */
  address?: Maybe<Scalars['String']>;
  /** The channel used for this device to communicate with a peripheral */
  channel?: Maybe<DeviceChannelForTcpConnection>;
  /** The device this rule is intended for */
  device_type?: Maybe<Scalars['String']>;
  /** Indicates if this rule is used as the primary or secondary hot water source */
  hot_water_source_type?: Maybe<Scalars['String']>;
  /** Metadata associated with this rule */
  metadata?: Maybe<BeeConfigurationRuleInputMetadata>;
  /** Indicates if this rule is used as the primary zone temperature sensor */
  primary_zone_temperature_sensor?: Maybe<Scalars['String']>;
  /** The zone this rule is set for */
  zone_id?: Maybe<Scalars['String']>;
};

/** Describes the metadata for rule input */
export type BeeConfigurationRuleInputMetadata = {
  __typename?: 'BeeConfigurationRuleInputMetadata';
  circuit_type?: Maybe<Scalars['String']>;
  clamp_1_circuit_type?: Maybe<Scalars['String']>;
  clamp_2_circuit_type?: Maybe<Scalars['String']>;
  clamp_3_circuit_type?: Maybe<Scalars['String']>;
};

/** Describes the metadata for a rule */
export type BeeConfigurationRuleMetadata = {
  __typename?: 'BeeConfigurationRuleMetadata';
  action_type?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  circuit_label?: Maybe<Scalars['String']>;
  clamp_1_circuit_label?: Maybe<Scalars['String']>;
  clamp_2_circuit_label?: Maybe<Scalars['String']>;
  clamp_3_circuit_label?: Maybe<Scalars['String']>;
  dip_switch_position?: Maybe<Scalars['Int']>;
  heat_flow_meter_circuit?: Maybe<Scalars['String']>;
  heat_pump_heating_control?: Maybe<Scalars['String']>;
  heating_system?: Maybe<Scalars['String']>;
  install_location?: Maybe<Scalars['String']>;
  meter_amperage?: Maybe<Scalars['Int']>;
  non_metered_circuits?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** DeviceConfig data */
export type BeeDeviceConfig = {
  __typename?: 'BeeDeviceConfig';
  heating?: Maybe<DeviceConfigHeating>;
  hot_water_temperature?: Maybe<DeviceConfigHotWaterTemperature>;
  location?: Maybe<Scalars['String']>;
  temperature?: Maybe<DeviceConfigHeatingTemperature>;
};

/** Describes the response type for BEE Modes */
export type BeeModeResponse = {
  __typename?: 'BeeModeResponse';
  /** Modes of BEE operation */
  beeModes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Describes the data for BEEs that have been registered */
export type BeeSearchDataResponse = {
  __typename?: 'BeeSearchDataResponse';
  /** Indicates if all peripheral healthchecks for a BEE passed */
  arePeripheralsHealthy?: Maybe<Scalars['Boolean']>;
  /** Represents the BEE */
  bee?: Maybe<Bee>;
  /** The configuration for the BEE */
  config?: Maybe<Configuration>;
  /** The overall app version running on the BEE */
  currentAppVersion?: Maybe<Scalars['String']>;
  /** The hardware version the BEE is running on */
  hardwareVersion?: Maybe<Scalars['String']>;
  /** Timestamp of the last state update */
  lastStatusUpdate?: Maybe<Scalars['String']>;
  /** The latest firmware version available for this BEE */
  latestAppVersion?: Maybe<Scalars['String']>;
  /** A list of peripheral health checks */
  peripheralHealthChecks?: Maybe<Array<Maybe<PeripheralHealthCheckType>>>;
  /** The current status of the BEE */
  status?: Maybe<Scalars['String']>;
  /** How long the BEE has been up for */
  uptime?: Maybe<Scalars['String']>;
};

/** Describes BEEs that have been registered */
export type BeeSearchResponse = {
  __typename?: 'BeeSearchResponse';
  /** The number of total items */
  itemCount?: Maybe<Scalars['Int']>;
  /** BEEs meeting the query criteria */
  items?: Maybe<Array<Maybe<Bee>>>;
};

/** Describes the response type for statistical data in the Sero estate */
export type BeeStatisticsResponse = {
  __typename?: 'BeeStatisticsResponse';
  /** The number of BEEs that are offline */
  numberOfDevicesOffline?: Maybe<Scalars['Int']>;
  /** The number of BEEs that are online */
  numberOfDevicesOnline?: Maybe<Scalars['Int']>;
  /** The total number of BEEs */
  totalBees?: Maybe<Scalars['Int']>;
  /** The total number of healthcheck errors */
  totalHealthcheckErrors?: Maybe<Scalars['Int']>;
};

export enum BeeTag {
  Trustmark = 'TRUSTMARK'
}

/** Describes the response type for config profile versions */
export type ConfigProfileVersionsResponse = {
  __typename?: 'ConfigProfileVersionsResponse';
  /** Versions of config profile */
  configProfileVersions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Describes the data for BEEs that have been registered */
export type Configuration = {
  __typename?: 'Configuration';
  device_config?: Maybe<BeeDeviceConfig>;
  /** The configured devices for a BEE */
  devices?: Maybe<Array<Maybe<DeviceUnion>>>;
  /** The metadata for a BEE */
  metadata?: Maybe<ConfigurationMetadata>;
  /** The configured rules for a BEE */
  rules?: Maybe<Array<Maybe<BeeConfigurationRule>>>;
};

/** Describes the shape of a config metadata */
export type ConfigurationMetadata = {
  __typename?: 'ConfigurationMetadata';
  /** The mode of the BEE (monitor, control, billing etc) */
  beeMode?: Maybe<Scalars['String']>;
  /** The version of the config profile */
  configProfileVersion?: Maybe<Scalars['String']>;
};

/** Describes a supported control peripheral for a BEE along with its state and if you can change it */
export type ControlPeripheralResponse = {
  __typename?: 'ControlPeripheralResponse';
  /** Device category of peripheral */
  deviceCategory?: Maybe<Scalars['String']>;
  /** Device type of peripheral */
  deviceType?: Maybe<Scalars['String']>;
  /** Indicates if the user has permission to change the state of the peripheral */
  hasPermission?: Maybe<Scalars['Boolean']>;
  /** State of peripheral */
  state?: Maybe<Scalars['Float']>;
};

export type Creatable = {
  __typename?: 'Creatable';
  createdOn?: Maybe<Scalars['String']>;
};

/** Create a trial */
export type CreateTrial = {
  meterableUnitId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Describes the shape of a data point commisioning check */
export type DataPointCommissioningCheckType = {
  __typename?: 'DataPointCommissioningCheckType';
  /** The data point */
  name?: Maybe<Scalars['String']>;
  /** The status of the healthcheck for this data point */
  status?: Maybe<Scalars['String']>;
  /** The unit of the healthcheck value for this data point */
  unit?: Maybe<Scalars['String']>;
  /** The value of the healthcheck for this data point */
  value?: Maybe<Scalars['Float']>;
};

/** Describes the shape for a daily Heating Schedule */
export type DayHeatingSchedules = {
  __typename?: 'DayHeatingSchedules';
  /** The end time for this schedule */
  end?: Maybe<Scalars['String']>;
  /** The start time for this schedule */
  start?: Maybe<Scalars['String']>;
  /** The temperature for this schedule */
  temperature?: Maybe<Scalars['Float']>;
};

/** Delete a trial */
export type DeleteTrial = {
  id?: Maybe<Scalars['String']>;
  meterableUnitId?: Maybe<Scalars['String']>;
};

/** Describes the delete response */
export type DeleteTrialResponse = {
  __typename?: 'DeleteTrialResponse';
  /** The id of the deleted trial */
  affected?: Maybe<Scalars['Float']>;
};

/** Describes the shape of a Device Channel for a TCP connection */
export type DeviceChannelForTcpConnection = {
  __typename?: 'DeviceChannelForTCPConnection';
  /** The channel address */
  address?: Maybe<Scalars['String']>;
  /** The port (if this is a TCP connection) */
  port?: Maybe<Scalars['String']>;
};

/** Heating configuration for a BEE */
export type DeviceConfigHeating = {
  __typename?: 'DeviceConfigHeating';
  temperature?: Maybe<DeviceConfigHeatingTemperature>;
};

/** Heating temperature boundaries */
export type DeviceConfigHeatingTemperature = {
  __typename?: 'DeviceConfigHeatingTemperature';
  /** The minimum temperature for the heating system */
  lower?: Maybe<Scalars['Int']>;
  /** The maximum temperature for the heating system */
  upper?: Maybe<Scalars['Int']>;
};

/** Hot water temperature data */
export type DeviceConfigHotWaterTemperature = {
  __typename?: 'DeviceConfigHotWaterTemperature';
  off?: Maybe<Scalars['Int']>;
  on?: Maybe<Scalars['Int']>;
};

export type DeviceUnion = InternalDeviceType | MBusDeviceType | MasterthermDeviceType | ModBusDeviceType | RelayDeviceType;

/** Describes the outcome of updating the equinox trial */
export type EditEquinoxTrialResponse = {
  __typename?: 'EditEquinoxTrialResponse';
  /** An error message if the equniox update was not sent successfully */
  errorMessage?: Maybe<Scalars['String']>;
  /** Indicates if the Equinox field was updated successfully */
  success?: Maybe<Scalars['Boolean']>;
};

/** Describes the firmware version file names */
export type FirmwareVersionsFileNameResponse = {
  __typename?: 'FirmwareVersionsFileNameResponse';
  /** Version file names of firmware */
  firmwareVersions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Describes the firmware versions */
export type FirmwareVersionsResponse = {
  __typename?: 'FirmwareVersionsResponse';
  /** Versions of firmware */
  firmwareVersions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Describes supported control peripherals for a BEE */
export type GetControlPeripheralsResponse = {
  __typename?: 'GetControlPeripheralsResponse';
  /** Supported control peripherals */
  peripherals?: Maybe<Array<Maybe<ControlPeripheralResponse>>>;
};

export enum HeatStatus {
  Off = 'OFF',
  On = 'ON',
  Unknown = 'UNKNOWN'
}

/** Describes the state of the heating in the context of a BEE */
export type HeatingInformationResponse = {
  __typename?: 'HeatingInformationResponse';
  /** Heating status of a zone */
  heating_state?: Maybe<HeatStatus>;
  /** The lowest temperature that can be set for a zone */
  lower_bounds?: Maybe<Scalars['Float']>;
  /** Temperature set point in Celsius (c) precise to 1 decimal place (0.1) */
  setpoint?: Maybe<Scalars['Float']>;
  /** Temperature in Celsius (c) precise to 1 decimal place (0.1) */
  temperature?: Maybe<Scalars['Float']>;
  /** The highest temperature that can be set for a zone */
  upper_bounds?: Maybe<Scalars['Float']>;
};

/** Describes the outcome of overriding the heating in the context of a BEE */
export type HeatingOverrideResponse = {
  __typename?: 'HeatingOverrideResponse';
  /** An error message if the command was not sent successfully */
  error_message?: Maybe<Scalars['String']>;
  /** Indicates if the command was sent successfully */
  success: Scalars['Boolean'];
};

/** Describes a singular Heating Schedule */
export type HeatingSchedule = {
  __typename?: 'HeatingSchedule';
  /** The heating set-points of a schedule */
  setpoints?: Maybe<Array<Maybe<HeatingSetpoint>>>;
  /** The ID of a zone */
  zone_id?: Maybe<Scalars['ID']>;
};

/** Describes the outcome of creating the Weekly Heating Schedule */
export type HeatingScheduleCreationResponse = {
  __typename?: 'HeatingScheduleCreationResponse';
  /** An error message if the schedule was not sent successfully */
  errorMessage?: Maybe<Scalars['String']>;
  /** The created schedule */
  heatingSchedule?: Maybe<WeeklyHeatingScheduleResponse>;
  /** Indicates if the schedule was replaced successfully */
  success?: Maybe<Scalars['Boolean']>;
};

/** Describes the input criteria for a singular Heating Schedule */
export type HeatingScheduleInputs = {
  /** The heating set-points of a schedule */
  setpoints?: Maybe<Array<HeatingSetpointInputs>>;
  /** The ID of a zone */
  zone_id?: Maybe<Scalars['ID']>;
};

/** Describes the shape of a list of heating schedules for a chosen day */
export type HeatingSchedulesByDayResponse = {
  __typename?: 'HeatingSchedulesByDayResponse';
  /** The heating schedules for a day */
  schedules?: Maybe<Array<Maybe<DayHeatingSchedules>>>;
  /** The ID of the zone we are showing schedules for */
  zone_id?: Maybe<Scalars['String']>;
};

/** Describes the shape of a list of heating schedules for a chosen day */
export type HeatingSchedulesResponse = {
  __typename?: 'HeatingSchedulesResponse';
  /** The heating schedule for friday */
  friday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
  /** The heating schedule for monday */
  monday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
  /** The heating schedule for saturday */
  saturday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
  /** The heating schedule for sunday */
  sunday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
  /** The heating schedule for thursday */
  thursday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
  /** The heating schedule for tuesday */
  tuesday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
  /** The heating schedule for wednesday */
  wednesday?: Maybe<Array<HeatingSchedulesByDayResponse>>;
};

/** Describes a Heating Set-point */
export type HeatingSetpoint = {
  __typename?: 'HeatingSetpoint';
  /** The temperature set-point */
  temperature?: Maybe<Scalars['Float']>;
  /** The starting point of the schedule */
  time?: Maybe<Scalars['String']>;
  /** The type of setpoint being start or end for UI purposes */
  type?: Maybe<Scalars['String']>;
  /** The chosen time by the user */
  user_time?: Maybe<Scalars['String']>;
};

/** Describes the input criteria for a Heating Set-point */
export type HeatingSetpointInputs = {
  /** The temperature set-point in Celsius */
  temperature?: Maybe<Scalars['Float']>;
  /** The starting point of the schedule in hours and minutes in the format ^(2[0-3]|[01][0-9]):([0-5][0-9])$. e.g. 09:30 */
  time?: Maybe<Scalars['String']>;
  /** The type of set-point */
  type?: Maybe<Scalars['String']>;
};

/** Describes the state of the hot water in the context of a BEE */
export type HotWaterAuditResponse = {
  __typename?: 'HotWaterAuditResponse';
  /** The user or system who made the change */
  by?: Maybe<Scalars['String']>;
  /** The day changed */
  day?: Maybe<Scalars['String']>;
  /** The time changed */
  time?: Maybe<Scalars['String']>;
};

/** Describes the outcome of overriding the heating in the context of a BEE */
export type HotWaterOverrideResponse = {
  __typename?: 'HotWaterOverrideResponse';
  /** An error message if the command was not sent successfully */
  error_message?: Maybe<Scalars['String']>;
  /** Indicates if the command was sent successfully */
  success: Scalars['Boolean'];
};

/** Describes the state of the hot water in the context of a BEE */
export type HotWaterResponse = {
  __typename?: 'HotWaterResponse';
  /** Device hot water is active */
  device_hot_water_active?: Maybe<Scalars['Float']>;
  /** Hot water is active or not */
  hot_water_active?: Maybe<Scalars['Float']>;
  /** Current status of the hot water schedule */
  schedule_hot_water_active?: Maybe<Scalars['Float']>;
  /** Audit of the hot water */
  set_at?: Maybe<HotWaterAuditResponse>;
};

/** Describes the outcome of creating the Weekly Hot Water Schedule */
export type HotWaterScheduleCreationResponse = {
  __typename?: 'HotWaterScheduleCreationResponse';
  /** An error message if the hot water schedule was not sent successfully */
  errorMessage?: Maybe<Scalars['String']>;
  /** Indicates if the hot water schedule was replaced successfully */
  success?: Maybe<Scalars['Boolean']>;
};

/** Describes setpoints for hot water */
export type HotWaterScheduleInputs = {
  /** The times to turn on or off hot water */
  setpoints: Array<HotWaterScheduleSetpointInputs>;
  /** The zone of the hot water water */
  zone_id: Scalars['String'];
};

/** Describes setpoints for hot water */
export type HotWaterScheduleResponse = {
  __typename?: 'HotWaterScheduleResponse';
  /** The times to turn on or off hot water */
  setpoints: Array<HotWaterScheduleSetpointResponse>;
  /** The zone of the hot water water */
  zone_id: Scalars['String'];
};

/** Describes the time hot water should be on or off */
export type HotWaterScheduleSetpointInputs = {
  /** Flag to show if water is being heated */
  hot_water_active: Scalars['Int'];
  /** The time to turn on or off hot water on the BEE */
  time: Scalars['String'];
  /** The chosen time by the user */
  user_time?: Maybe<Scalars['String']>;
};

/** Describes the time hot water should be on or off */
export type HotWaterScheduleSetpointResponse = {
  __typename?: 'HotWaterScheduleSetpointResponse';
  /** Flag to show if water is being heated */
  hot_water_active: Scalars['Int'];
  /** The time to turn on or off hot water on the BEE */
  time: Scalars['String'];
  /** The chosen time by the user */
  user_time?: Maybe<Scalars['String']>;
};

/** Describes hot water schedules */
export type HotWaterSchedulesResponse = {
  __typename?: 'HotWaterSchedulesResponse';
  /** The hot water schedule for friday */
  friday?: Maybe<Array<HotWaterScheduleResponse>>;
  /** The hot water schedule for monday */
  monday?: Maybe<Array<HotWaterScheduleResponse>>;
  /** The hot water schedule for saturday */
  saturday?: Maybe<Array<HotWaterScheduleResponse>>;
  /** The hot water schedule for sunday */
  sunday?: Maybe<Array<HotWaterScheduleResponse>>;
  /** The hot water schedule for thursday */
  thursday?: Maybe<Array<HotWaterScheduleResponse>>;
  /** The hot water schedule for tuesday */
  tuesday?: Maybe<Array<HotWaterScheduleResponse>>;
  /** The hot water schedule for wednesday */
  wednesday?: Maybe<Array<HotWaterScheduleResponse>>;
};

export enum HotWaterSource {
  CombiBoiler = 'COMBI_BOILER',
  HeatPump = 'HEAT_PUMP',
  ImmersionHeater = 'IMMERSION_HEATER',
  Other = 'OTHER',
  SystemBoiler = 'SYSTEM_BOILER'
}

/** Describes hot water sources */
export type HotWaterSourceResponse = {
  __typename?: 'HotWaterSourceResponse';
  /** The hot water sources available */
  hotWaterSources?: Maybe<Array<HotWaterSource>>;
};

/** Describes the internal device type for a BEE configuration */
export type InternalDeviceType = {
  __typename?: 'InternalDeviceType';
  /** The address which the device needs to communicate with */
  fields?: Maybe<Array<Maybe<ModbusDeviceFieldsType>>>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  /** The protocol this device uses */
  protocol?: Maybe<Scalars['String']>;
};

/** Describes the MBus device type for a BEE configuration */
export type MBusDeviceType = {
  __typename?: 'MBusDeviceType';
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  /** The protocol this device uses */
  protocol?: Maybe<Scalars['String']>;
};

/** Describes the Mastertherm device type fields for a BEE configuration */
export type MasterthermDeviceFieldsType = {
  __typename?: 'MasterthermDeviceFieldsType';
  /** The format of the field */
  compressor_off_time?: Maybe<Scalars['String']>;
  /** The name of the field */
  temperature?: Maybe<Scalars['String']>;
};

/** Describes the Relay device type for a BEE configuration */
export type MasterthermDeviceType = {
  __typename?: 'MasterthermDeviceType';
  /** The fields for the modbus device */
  fields?: Maybe<Array<Maybe<MasterthermDeviceFieldsType>>>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  /** The protocol this device uses */
  protocol?: Maybe<Scalars['String']>;
};

/** Describes the Modbus device type for a BEE configuration */
export type ModBusDeviceType = {
  __typename?: 'ModBusDeviceType';
  /** The fields for the modbus device */
  fields?: Maybe<Array<Maybe<ModbusDeviceFieldsType>>>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  /** The protocol this device uses */
  protocol?: Maybe<Scalars['String']>;
};

/** Describes the Modbus device type fields for a BEE configuration */
export type ModbusDeviceFieldsType = {
  __typename?: 'ModbusDeviceFieldsType';
  /** The type of access this device uses to get this value */
  access?: Maybe<Scalars['String']>;
  /** The address which the device needs to communicate with */
  address?: Maybe<Scalars['String']>;
  /** The factor this field reports in */
  factor?: Maybe<Scalars['Float']>;
  /** The format of the field */
  format?: Maybe<Scalars['String']>;
  /** The number of bits returned */
  length?: Maybe<Scalars['String']>;
  /** The name of the field */
  name?: Maybe<Scalars['String']>;
  /** The unit this field reports in */
  unit?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Set hot water schedules for a specific BEE. The times the water heating is turned on and off for each day of the week. */
  createHotWaterSchedules?: Maybe<HotWaterScheduleCreationResponse>;
  /** Create a new trial */
  createTrial?: Maybe<TrialResponse>;
  /** Create a heating schedule for a specific BEE */
  createWeeklyHeatingSchedule?: Maybe<HeatingScheduleCreationResponse>;
  /** Hard delete a trial */
  deleteTrial?: Maybe<DeleteTrialResponse>;
  /** Edit Trial */
  editEquinoxTrial?: Maybe<EditEquinoxTrialResponse>;
  /** Override heating set point for a specific BEE. Heating can be controlled by zone */
  overrideHeating?: Maybe<HeatingOverrideResponse>;
  /** Override hot water set point for a specific BEE */
  overrideHotWater?: Maybe<HotWaterOverrideResponse>;
  /** Send a command to a peripheral */
  sendPeripheralCommand?: Maybe<PeripheralCommandResponse>;
  /** Update BEE */
  updateBee?: Maybe<BeeSearchDataResponse>;
  /** Upgrade firmware */
  upgradeFirmware?: Maybe<UpgradeFirmwareResponse>;
};


export type MutationCreateHotWaterSchedulesArgs = {
  deviceId?: Maybe<Scalars['ID']>;
  hotWaterSchedules?: Maybe<WeeklyHotWaterScheduleInputs>;
};


export type MutationCreateTrialArgs = {
  createInput?: Maybe<CreateTrial>;
};


export type MutationCreateWeeklyHeatingScheduleArgs = {
  deviceId?: Maybe<Scalars['ID']>;
  heatingSchedule?: Maybe<WeeklyHeatingScheduleInputs>;
};


export type MutationDeleteTrialArgs = {
  deleteInput?: Maybe<DeleteTrial>;
};


export type MutationEditEquinoxTrialArgs = {
  deviceId?: Maybe<Scalars['String']>;
  flag?: Maybe<Scalars['Boolean']>;
};


export type MutationOverrideHeatingArgs = {
  beeId?: Maybe<Scalars['ID']>;
  setpoint?: Maybe<Scalars['Float']>;
  zoneId?: Maybe<Scalars['ID']>;
};


export type MutationOverrideHotWaterArgs = {
  deviceId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};


export type MutationSendPeripheralCommandArgs = {
  deviceId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  requestedState?: Maybe<Scalars['Float']>;
};


export type MutationUpdateBeeArgs = {
  bee?: Maybe<UpdateBee>;
};


export type MutationUpgradeFirmwareArgs = {
  upgradeFirmware?: Maybe<UpgradeFirmwareRequest>;
};

export type Paging = {
  __typename?: 'Paging';
  /** Current page */
  current?: Maybe<Scalars['String']>;
  /** Next page if present */
  next?: Maybe<Scalars['String']>;
  /** Previous page if not first page */
  previous?: Maybe<Scalars['String']>;
};

export type PagingQuery = {
  /** Current page */
  page?: Maybe<Scalars['String']>;
  /** Page size */
  pageSize?: Maybe<Scalars['Float']>;
};

/** Describes the outcome of sending a command to a peripheral */
export type PeripheralCommandResponse = {
  __typename?: 'PeripheralCommandResponse';
  /** An error message if the peripheral command was not sent successfully */
  errorMessage?: Maybe<Scalars['String']>;
  /** Indicates if the command was successfully sent to the peripheral */
  success?: Maybe<Scalars['Boolean']>;
};

/** Describes the shape of a peripheral health check */
export type PeripheralHealthCheckType = {
  __typename?: 'PeripheralHealthCheckType';
  /** The peripheral data packet */
  data?: Maybe<Scalars['String']>;
  datapoint_checks?: Maybe<Array<Maybe<DataPointCommissioningCheckType>>>;
  /** The device type */
  device_type?: Maybe<Scalars['String']>;
  /** The reason the healthcheck failed */
  reason?: Maybe<Scalars['String']>;
  /** The status of the healthcheck for this device */
  status?: Maybe<Scalars['String']>;
  /** The time the healthcheck was last run */
  timestamp?: Maybe<Scalars['String']>;
  /** The zone ID */
  zone_id?: Maybe<Scalars['String']>;
};

export type PropertyAddress = {
  __typename?: 'PropertyAddress';
  /** The address was entered manually instead of autocompleted */
  addressEnteredManually?: Maybe<Scalars['Boolean']>;
  /** The first line of the address */
  addressLine1?: Maybe<Scalars['String']>;
  /** The city */
  city?: Maybe<Scalars['String']>;
  /** The postcode */
  postcode?: Maybe<Scalars['String']>;
  /** The UDPRN for the property */
  udprn?: Maybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  /** List firmware version file names */
  firmwareVersions?: Maybe<FirmwareVersionsFileNameResponse>;
  /** Get available config list */
  getAvailableConfigs?: Maybe<AvailableConfigsResponse>;
  /** Get bee modes */
  getBeeModes?: Maybe<BeeModeResponse>;
  /** Get statistics for all filtered bees */
  getBeeStatistics?: Maybe<BeeStatisticsResponse>;
  /** Get config profile versions */
  getConfigProfileVersions?: Maybe<ConfigProfileVersionsResponse>;
  /** Get all supported peripherals */
  getControlPeripherals?: Maybe<GetControlPeripheralsResponse>;
  /** Get firmware version list */
  getFirmwareVersions?: Maybe<FirmwareVersionsResponse>;
  /** Get heating status reported by the BEE for a zone */
  getHeatingInformation?: Maybe<HeatingInformationResponse>;
  /** Get hot water information */
  getHotWaterInformation?: Maybe<HotWaterResponse>;
  /** Get hot water schedules for a specific BEE. The times the water heating is turned on and off for each day of the week. */
  getHotWaterSchedules?: Maybe<HotWaterSchedulesResponse>;
  /** Get hot water sources */
  getHotWaterSources?: Maybe<HotWaterSourceResponse>;
  /** Get the heating schedules of a BEE */
  getWeeklyHeatingSchedule?: Maybe<HeatingSchedulesResponse>;
  /** @deprecated Get the heating schedules stored on the BEE for a zone */
  getWeeklyHeatingScheduleByZone?: Maybe<WeeklyHeatingScheduleResponse>;
  /** Return a full list of trials */
  listTrials?: Maybe<TrialSearchResponse>;
  /** Search all bee data */
  searchBeeData?: Maybe<BeeSearchDataResponse>;
  /** Search all bees */
  searchBees?: Maybe<BeeSearchResponse>;
  /** Search all zones */
  searchZones?: Maybe<ZoneSearchResponse>;
};


export type QueryFirmwareVersionsArgs = {
  deviceId?: Maybe<Scalars['String']>;
  hardwareVersion?: Maybe<Scalars['String']>;
};


export type QueryGetBeeStatisticsArgs = {
  query?: Maybe<QueryBee>;
};


export type QueryGetControlPeripheralsArgs = {
  deviceId?: Maybe<Scalars['ID']>;
};


export type QueryGetHeatingInformationArgs = {
  beeId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
};


export type QueryGetHotWaterInformationArgs = {
  deviceId?: Maybe<Scalars['ID']>;
};


export type QueryGetHotWaterSchedulesArgs = {
  deviceId?: Maybe<Scalars['ID']>;
  getNextSchedule?: Maybe<Scalars['Boolean']>;
};


export type QueryGetWeeklyHeatingScheduleArgs = {
  deviceId?: Maybe<Scalars['ID']>;
};


export type QueryGetWeeklyHeatingScheduleByZoneArgs = {
  deviceId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
};


export type QuerySearchBeeDataArgs = {
  query?: Maybe<QueryBee>;
};


export type QuerySearchBeesArgs = {
  query?: Maybe<QueryBee>;
};


export type QuerySearchZonesArgs = {
  deviceId?: Maybe<Scalars['String']>;
};

/** Query criteria for BEEs */
export type QueryBee = {
  /** The or restrictions to apply */
  or?: Maybe<Array<Maybe<QueryWhere>>>;
  /** Current page */
  page?: Maybe<Scalars['Int']>;
  /** Page size */
  pageSize?: Maybe<Scalars['Int']>;
  /** The where restrictions to apply */
  where?: Maybe<Array<Maybe<QueryWhere>>>;
};

export enum QueryOperator {
  Between = 'between',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  In = 'in',
  IsNull = 'isNull',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  Like = 'like',
  Not = 'not'
}

/** Query criteria for Trials */
export type QueryTrial = {
  or?: Maybe<Array<Maybe<QueryWhere>>>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  where?: Maybe<Array<Maybe<QueryWhere>>>;
};

export type QueryWhere = {
  /** The property key the restriction is applied to */
  key?: Maybe<Scalars['String']>;
  /** The operator to apply */
  operator?: Maybe<QueryOperator>;
  /** The first value of the restriction */
  valueOne?: Maybe<Scalars['String']>;
  /** The second value of the restriction */
  valueTwo?: Maybe<Scalars['String']>;
};

/** Describes the Relay device type for a BEE configuration */
export type RelayDeviceType = {
  __typename?: 'RelayDeviceType';
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  /** The protocol this device uses */
  protocol?: Maybe<Scalars['String']>;
};

/** Shows statistical data for BEEs in the Sero estate */
export type Stats = {
  __typename?: 'Stats';
  /** The number of BEEs that are offline */
  numberOfDevicesOffline?: Maybe<Scalars['Int']>;
  /** The number of BEEs that are online */
  numberOfDevicesOnline?: Maybe<Scalars['Int']>;
  /** The total number of BEEs */
  totalBees?: Maybe<Scalars['Int']>;
  /** The total number of healthcheck errors */
  totalHealthcheckErrors?: Maybe<Scalars['Int']>;
};

/** Describes a Trial */
export type Trial = {
  __typename?: 'Trial';
  /** Who created the data entry */
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  /** The Id for the trial that this object relates to */
  id?: Maybe<Scalars['String']>;
  /** The id of the meter that we are using on the trial */
  meterableUnitId?: Maybe<Scalars['String']>;
  /** The name of the trial */
  name?: Maybe<Scalars['String']>;
  /** Who updated the data entry last */
  updatedBy?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/** Describes a Trial response */
export type TrialResponse = {
  __typename?: 'TrialResponse';
  /** The Id for the trial that this object relates to */
  id?: Maybe<Scalars['String']>;
  /** The id of the trial group */
  meterableUnitId?: Maybe<Scalars['String']>;
  /** The name of the trial */
  name?: Maybe<Scalars['String']>;
};

/** Describes all trial response */
export type TrialSearchResponse = {
  __typename?: 'TrialSearchResponse';
  /** The number of total items */
  itemCount?: Maybe<Scalars['Int']>;
  /** Trials meeting the query criteria */
  items?: Maybe<Array<Maybe<Trial>>>;
};

export type UpdatableCreatable = {
  __typename?: 'UpdatableCreatable';
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

export type UpdatableCreatableCompletable = {
  __typename?: 'UpdatableCreatableCompletable';
  completedOn?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

/** Describes a BEE */
export type UpdateBee = {
  /** The device ID, a global identifier for the BEE which can be used to control a property. The device ID in which to control a property can change if the BEE hardware is replaced */
  deviceId?: Maybe<Scalars['String']>;
  /** The tags associated to this BEE */
  tags?: Maybe<Array<Maybe<BeeTag>>>;
  /** ID of the trial that the bee is participating in */
  trialId?: Maybe<Scalars['String']>;
};

/** Initiate a firmware upgrade process for a BEE */
export type UpgradeFirmwareRequest = {
  /** Determines the BEE to upgrade */
  deviceId?: Maybe<Scalars['String']>;
  /** Determines the BEEs to upgrade */
  deviceIds?: Maybe<Array<Scalars['String']>>;
  /** File to send to BEE to upgrade */
  file?: Maybe<Scalars['String']>;
};

/** Describes the upgrade firmware URL */
export type UpgradeFirmwareResponse = {
  __typename?: 'UpgradeFirmwareResponse';
  /** URL for BEE to download firmware */
  url?: Maybe<Scalars['String']>;
};

/** Describes the input criteria for a Weekly Heating Schedule */
export type WeeklyHeatingScheduleInputs = {
  /** The heating schedule for friday */
  friday?: Maybe<Array<HeatingScheduleInputs>>;
  /** The heating schedule for monday */
  monday?: Maybe<Array<HeatingScheduleInputs>>;
  /** The heating schedule for saturday */
  saturday?: Maybe<Array<HeatingScheduleInputs>>;
  /** The heating schedule for sunday */
  sunday?: Maybe<Array<HeatingScheduleInputs>>;
  /** The heating schedule for thursday */
  thursday?: Maybe<Array<HeatingScheduleInputs>>;
  /** The heating schedule for tuesday */
  tuesday?: Maybe<Array<HeatingScheduleInputs>>;
  /** The heating schedule for wednesday */
  wednesday?: Maybe<Array<HeatingScheduleInputs>>;
};

/** Describes a Weekly Heating Schedule */
export type WeeklyHeatingScheduleResponse = {
  __typename?: 'WeeklyHeatingScheduleResponse';
  /** The heating schedule for friday */
  friday?: Maybe<Array<HeatingSchedule>>;
  /** The heating schedule for monday */
  monday?: Maybe<Array<HeatingSchedule>>;
  /** The heating schedule for saturday */
  saturday?: Maybe<Array<HeatingSchedule>>;
  /** The heating schedule for sunday */
  sunday?: Maybe<Array<HeatingSchedule>>;
  /** The heating schedule for thursday */
  thursday?: Maybe<Array<HeatingSchedule>>;
  /** The heating schedule for tuesday */
  tuesday?: Maybe<Array<HeatingSchedule>>;
  /** The heating schedule for wednesday */
  wednesday?: Maybe<Array<HeatingSchedule>>;
};

/** Describes hot water schedules */
export type WeeklyHotWaterScheduleInputs = {
  /** The hot water schedule for friday */
  friday?: Maybe<Array<HotWaterScheduleInputs>>;
  /** The hot water schedule for monday */
  monday?: Maybe<Array<HotWaterScheduleInputs>>;
  /** The hot water schedule for saturday */
  saturday?: Maybe<Array<HotWaterScheduleInputs>>;
  /** The hot water schedule for sunday */
  sunday?: Maybe<Array<HotWaterScheduleInputs>>;
  /** The hot water schedule for thursday */
  thursday?: Maybe<Array<HotWaterScheduleInputs>>;
  /** The hot water schedule for tuesday */
  tuesday?: Maybe<Array<HotWaterScheduleInputs>>;
  /** The hot water schedule for wednesday */
  wednesday?: Maybe<Array<HotWaterScheduleInputs>>;
};

export type WhereQuery = {
  /** The where restrictions to apply */
  where?: Maybe<Array<Maybe<QueryWhere>>>;
};

/** Describes a zone */
export type Zone = {
  __typename?: 'Zone';
  /** The description of the zone */
  description?: Maybe<Scalars['String']>;
  /** Heating status of a zone */
  heating_state?: Maybe<HeatStatus>;
  /** The lowest temperature a device can go */
  lower_bounds?: Maybe<Scalars['Float']>;
  /** The target temperature of the zone */
  setpoint?: Maybe<Scalars['Float']>;
  /** The current temperature of the zone */
  temperature?: Maybe<Scalars['Float']>;
  /** The highest temperature a device can go */
  upper_bounds?: Maybe<Scalars['Float']>;
  /** The name of the zone used as an ID */
  zone_id?: Maybe<Scalars['String']>;
};

/** Describes all zones */
export type ZoneSearchResponse = {
  __typename?: 'ZoneSearchResponse';
  /** The number of total items */
  itemCount?: Maybe<Scalars['Int']>;
  /** Zones meeting the query criteria */
  items?: Maybe<Array<Maybe<Zone>>>;
};

export type CreateHotWaterSchedulesMutationVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
  hotWaterSchedules?: Maybe<WeeklyHotWaterScheduleInputs>;
}>;


export type CreateHotWaterSchedulesMutation = (
  { __typename?: 'Mutation' }
  & { createHotWaterSchedules?: Maybe<(
    { __typename?: 'HotWaterScheduleCreationResponse' }
    & Pick<HotWaterScheduleCreationResponse, 'errorMessage' | 'success'>
  )> }
);

export type CreateTrialMutationVariables = Exact<{
  createInput?: Maybe<CreateTrial>;
}>;


export type CreateTrialMutation = (
  { __typename?: 'Mutation' }
  & { createTrial?: Maybe<(
    { __typename?: 'TrialResponse' }
    & Pick<TrialResponse, 'id' | 'meterableUnitId' | 'name'>
  )> }
);

export type CreateWeeklyHeatingScheduleMutationVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
  heatingSchedule?: Maybe<WeeklyHeatingScheduleInputs>;
}>;


export type CreateWeeklyHeatingScheduleMutation = (
  { __typename?: 'Mutation' }
  & { createWeeklyHeatingSchedule?: Maybe<(
    { __typename?: 'HeatingScheduleCreationResponse' }
    & Pick<HeatingScheduleCreationResponse, 'errorMessage' | 'success'>
    & { heatingSchedule?: Maybe<(
      { __typename?: 'WeeklyHeatingScheduleResponse' }
      & { friday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>>, monday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>>, saturday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>>, sunday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>>, thursday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>>, tuesday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>>, wednesday?: Maybe<Array<(
        { __typename?: 'HeatingSchedule' }
        & Pick<HeatingSchedule, 'zone_id'>
        & { setpoints?: Maybe<Array<Maybe<(
          { __typename?: 'HeatingSetpoint' }
          & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
        )>>> }
      )>> }
    )> }
  )> }
);

export type DeleteTrialMutationVariables = Exact<{
  deleteInput?: Maybe<DeleteTrial>;
}>;


export type DeleteTrialMutation = (
  { __typename?: 'Mutation' }
  & { deleteTrial?: Maybe<(
    { __typename?: 'DeleteTrialResponse' }
    & Pick<DeleteTrialResponse, 'affected'>
  )> }
);

export type EditEquinoxTrialMutationVariables = Exact<{
  deviceId?: Maybe<Scalars['String']>;
  flag?: Maybe<Scalars['Boolean']>;
}>;


export type EditEquinoxTrialMutation = (
  { __typename?: 'Mutation' }
  & { editEquinoxTrial?: Maybe<(
    { __typename?: 'EditEquinoxTrialResponse' }
    & Pick<EditEquinoxTrialResponse, 'errorMessage' | 'success'>
  )> }
);

export type OverrideHeatingMutationVariables = Exact<{
  beeId?: Maybe<Scalars['ID']>;
  setpoint?: Maybe<Scalars['Float']>;
  zoneId?: Maybe<Scalars['ID']>;
}>;


export type OverrideHeatingMutation = (
  { __typename?: 'Mutation' }
  & { overrideHeating?: Maybe<(
    { __typename?: 'HeatingOverrideResponse' }
    & Pick<HeatingOverrideResponse, 'error_message' | 'success'>
  )> }
);

export type OverrideHotWaterMutationVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
}>;


export type OverrideHotWaterMutation = (
  { __typename?: 'Mutation' }
  & { overrideHotWater?: Maybe<(
    { __typename?: 'HotWaterOverrideResponse' }
    & Pick<HotWaterOverrideResponse, 'error_message' | 'success'>
  )> }
);

export type SendPeripheralCommandMutationVariables = Exact<{
  deviceId?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  requestedState?: Maybe<Scalars['Float']>;
}>;


export type SendPeripheralCommandMutation = (
  { __typename?: 'Mutation' }
  & { sendPeripheralCommand?: Maybe<(
    { __typename?: 'PeripheralCommandResponse' }
    & Pick<PeripheralCommandResponse, 'errorMessage' | 'success'>
  )> }
);

export type UpdateBeeMutationVariables = Exact<{
  bee?: Maybe<UpdateBee>;
}>;


export type UpdateBeeMutation = (
  { __typename?: 'Mutation' }
  & { updateBee?: Maybe<(
    { __typename?: 'BeeSearchDataResponse' }
    & Pick<BeeSearchDataResponse, 'arePeripheralsHealthy' | 'currentAppVersion' | 'hardwareVersion' | 'lastStatusUpdate' | 'latestAppVersion' | 'status' | 'uptime'>
    & { bee?: Maybe<(
      { __typename?: 'Bee' }
      & Pick<Bee, 'arePeripheralsHealthy' | 'createdOn' | 'currentAppVersion' | 'currentFirmwareVersion' | 'deviceId' | 'firmwareUpdateRequested' | 'firmwareUpdateVersion' | 'firmwareVersion' | 'hardwareVersion' | 'inActiveTrialEvent' | 'isHealthy' | 'isHeatSourceOn' | 'plot' | 'project' | 'routerId' | 'stateLastUpdated' | 'status' | 'stickerImage' | 'tags' | 'trialId' | 'updatedOn' | 'uprn'>
      & { physicalAddress?: Maybe<(
        { __typename?: 'PropertyAddress' }
        & Pick<PropertyAddress, 'addressEnteredManually' | 'addressLine1' | 'city' | 'postcode' | 'udprn'>
      )>, trial?: Maybe<(
        { __typename?: 'Trial' }
        & Pick<Trial, 'createdBy' | 'createdOn' | 'id' | 'meterableUnitId' | 'name' | 'updatedBy' | 'updatedOn'>
      )> }
    )>, config?: Maybe<(
      { __typename?: 'Configuration' }
      & { device_config?: Maybe<(
        { __typename?: 'BeeDeviceConfig' }
        & Pick<BeeDeviceConfig, 'location'>
        & { heating?: Maybe<(
          { __typename?: 'DeviceConfigHeating' }
          & { temperature?: Maybe<(
            { __typename?: 'DeviceConfigHeatingTemperature' }
            & Pick<DeviceConfigHeatingTemperature, 'lower' | 'upper'>
          )> }
        )>, hot_water_temperature?: Maybe<(
          { __typename?: 'DeviceConfigHotWaterTemperature' }
          & Pick<DeviceConfigHotWaterTemperature, 'off' | 'on'>
        )>, temperature?: Maybe<(
          { __typename?: 'DeviceConfigHeatingTemperature' }
          & Pick<DeviceConfigHeatingTemperature, 'lower' | 'upper'>
        )> }
      )>, devices?: Maybe<Array<Maybe<(
        { __typename?: 'InternalDeviceType' }
        & Pick<InternalDeviceType, 'name' | 'protocol'>
        & { fields?: Maybe<Array<Maybe<(
          { __typename?: 'ModbusDeviceFieldsType' }
          & Pick<ModbusDeviceFieldsType, 'access' | 'address' | 'factor' | 'format' | 'length' | 'name' | 'unit'>
        )>>> }
      ) | (
        { __typename?: 'MBusDeviceType' }
        & Pick<MBusDeviceType, 'name' | 'protocol'>
      ) | (
        { __typename?: 'MasterthermDeviceType' }
        & Pick<MasterthermDeviceType, 'name' | 'protocol'>
        & { fields?: Maybe<Array<Maybe<(
          { __typename?: 'MasterthermDeviceFieldsType' }
          & Pick<MasterthermDeviceFieldsType, 'compressor_off_time' | 'temperature'>
        )>>> }
      ) | (
        { __typename?: 'ModBusDeviceType' }
        & Pick<ModBusDeviceType, 'name' | 'protocol'>
        & { fields?: Maybe<Array<Maybe<(
          { __typename?: 'ModbusDeviceFieldsType' }
          & Pick<ModbusDeviceFieldsType, 'access' | 'address' | 'factor' | 'format' | 'length' | 'name' | 'unit'>
        )>>> }
      ) | (
        { __typename?: 'RelayDeviceType' }
        & Pick<RelayDeviceType, 'name' | 'protocol'>
      )>>>, metadata?: Maybe<(
        { __typename?: 'ConfigurationMetadata' }
        & Pick<ConfigurationMetadata, 'beeMode' | 'configProfileVersion'>
      )>, rules?: Maybe<Array<Maybe<(
        { __typename?: 'BeeConfigurationRule' }
        & Pick<BeeConfigurationRule, 'name'>
        & { inputs?: Maybe<(
          { __typename?: 'BeeConfigurationRuleInput' }
          & Pick<BeeConfigurationRuleInput, 'address' | 'device_type' | 'hot_water_source_type' | 'primary_zone_temperature_sensor' | 'zone_id'>
          & { channel?: Maybe<(
            { __typename?: 'DeviceChannelForTCPConnection' }
            & Pick<DeviceChannelForTcpConnection, 'address' | 'port'>
          )>, metadata?: Maybe<(
            { __typename?: 'BeeConfigurationRuleInputMetadata' }
            & Pick<BeeConfigurationRuleInputMetadata, 'circuit_type' | 'clamp_1_circuit_type' | 'clamp_2_circuit_type' | 'clamp_3_circuit_type'>
          )> }
        )>, metadata?: Maybe<(
          { __typename?: 'BeeConfigurationRuleMetadata' }
          & Pick<BeeConfigurationRuleMetadata, 'action_type' | 'category' | 'circuit_label' | 'clamp_1_circuit_label' | 'clamp_2_circuit_label' | 'clamp_3_circuit_label' | 'dip_switch_position' | 'heat_flow_meter_circuit' | 'heat_pump_heating_control' | 'heating_system' | 'install_location' | 'meter_amperage' | 'non_metered_circuits' | 'variant'>
        )> }
      )>>> }
    )>, peripheralHealthChecks?: Maybe<Array<Maybe<(
      { __typename?: 'PeripheralHealthCheckType' }
      & Pick<PeripheralHealthCheckType, 'data' | 'device_type' | 'reason' | 'status' | 'timestamp' | 'zone_id'>
      & { datapoint_checks?: Maybe<Array<Maybe<(
        { __typename?: 'DataPointCommissioningCheckType' }
        & Pick<DataPointCommissioningCheckType, 'name' | 'status' | 'unit' | 'value'>
      )>>> }
    )>>> }
  )> }
);

export type UpgradeFirmwareMutationVariables = Exact<{
  upgradeFirmware?: Maybe<UpgradeFirmwareRequest>;
}>;


export type UpgradeFirmwareMutation = (
  { __typename?: 'Mutation' }
  & { upgradeFirmware?: Maybe<(
    { __typename?: 'UpgradeFirmwareResponse' }
    & Pick<UpgradeFirmwareResponse, 'url'>
  )> }
);

export type FirmwareVersionsQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['String']>;
  hardwareVersion?: Maybe<Scalars['String']>;
}>;


export type FirmwareVersionsQuery = (
  { __typename?: 'Query' }
  & { firmwareVersions?: Maybe<(
    { __typename?: 'FirmwareVersionsFileNameResponse' }
    & Pick<FirmwareVersionsFileNameResponse, 'firmwareVersions'>
  )> }
);

export type GetAvailableConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableConfigsQuery = (
  { __typename?: 'Query' }
  & { getAvailableConfigs?: Maybe<(
    { __typename?: 'AvailableConfigsResponse' }
    & { availableConfigs?: Maybe<Array<Maybe<(
      { __typename?: 'AvailableConfig' }
      & Pick<AvailableConfig, 'displayName' | 'originalFileName'>
    )>>> }
  )> }
);

export type GetBeeModesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBeeModesQuery = (
  { __typename?: 'Query' }
  & { getBeeModes?: Maybe<(
    { __typename?: 'BeeModeResponse' }
    & Pick<BeeModeResponse, 'beeModes'>
  )> }
);

export type GetBeeStatisticsQueryVariables = Exact<{
  query?: Maybe<QueryBee>;
}>;


export type GetBeeStatisticsQuery = (
  { __typename?: 'Query' }
  & { getBeeStatistics?: Maybe<(
    { __typename?: 'BeeStatisticsResponse' }
    & Pick<BeeStatisticsResponse, 'numberOfDevicesOffline' | 'numberOfDevicesOnline' | 'totalBees' | 'totalHealthcheckErrors'>
  )> }
);

export type GetConfigProfileVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigProfileVersionsQuery = (
  { __typename?: 'Query' }
  & { getConfigProfileVersions?: Maybe<(
    { __typename?: 'ConfigProfileVersionsResponse' }
    & Pick<ConfigProfileVersionsResponse, 'configProfileVersions'>
  )> }
);

export type GetControlPeripheralsQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
}>;


export type GetControlPeripheralsQuery = (
  { __typename?: 'Query' }
  & { getControlPeripherals?: Maybe<(
    { __typename?: 'GetControlPeripheralsResponse' }
    & { peripherals?: Maybe<Array<Maybe<(
      { __typename?: 'ControlPeripheralResponse' }
      & Pick<ControlPeripheralResponse, 'deviceCategory' | 'deviceType' | 'hasPermission' | 'state'>
    )>>> }
  )> }
);

export type GetFirmwareVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFirmwareVersionsQuery = (
  { __typename?: 'Query' }
  & { getFirmwareVersions?: Maybe<(
    { __typename?: 'FirmwareVersionsResponse' }
    & Pick<FirmwareVersionsResponse, 'firmwareVersions'>
  )> }
);

export type GetHeatingInformationQueryVariables = Exact<{
  beeId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
}>;


export type GetHeatingInformationQuery = (
  { __typename?: 'Query' }
  & { getHeatingInformation?: Maybe<(
    { __typename?: 'HeatingInformationResponse' }
    & Pick<HeatingInformationResponse, 'heating_state' | 'lower_bounds' | 'setpoint' | 'temperature' | 'upper_bounds'>
  )> }
);

export type GetHotWaterInformationQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
}>;


export type GetHotWaterInformationQuery = (
  { __typename?: 'Query' }
  & { getHotWaterInformation?: Maybe<(
    { __typename?: 'HotWaterResponse' }
    & Pick<HotWaterResponse, 'device_hot_water_active' | 'hot_water_active' | 'schedule_hot_water_active'>
    & { set_at?: Maybe<(
      { __typename?: 'HotWaterAuditResponse' }
      & Pick<HotWaterAuditResponse, 'by' | 'day' | 'time'>
    )> }
  )> }
);

export type GetHotWaterSchedulesQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
  getNextSchedule?: Maybe<Scalars['Boolean']>;
}>;


export type GetHotWaterSchedulesQuery = (
  { __typename?: 'Query' }
  & { getHotWaterSchedules?: Maybe<(
    { __typename?: 'HotWaterSchedulesResponse' }
    & { friday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>>, monday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>>, saturday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>>, sunday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>>, thursday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>>, tuesday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>>, wednesday?: Maybe<Array<(
      { __typename?: 'HotWaterScheduleResponse' }
      & Pick<HotWaterScheduleResponse, 'zone_id'>
      & { setpoints: Array<(
        { __typename?: 'HotWaterScheduleSetpointResponse' }
        & Pick<HotWaterScheduleSetpointResponse, 'hot_water_active' | 'time' | 'user_time'>
      )> }
    )>> }
  )> }
);

export type GetHotWaterSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHotWaterSourcesQuery = (
  { __typename?: 'Query' }
  & { getHotWaterSources?: Maybe<(
    { __typename?: 'HotWaterSourceResponse' }
    & Pick<HotWaterSourceResponse, 'hotWaterSources'>
  )> }
);

export type GetWeeklyHeatingScheduleQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
}>;


export type GetWeeklyHeatingScheduleQuery = (
  { __typename?: 'Query' }
  & { getWeeklyHeatingSchedule?: Maybe<(
    { __typename?: 'HeatingSchedulesResponse' }
    & { friday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>>, monday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>>, saturday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>>, sunday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>>, thursday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>>, tuesday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>>, wednesday?: Maybe<Array<(
      { __typename?: 'HeatingSchedulesByDayResponse' }
      & Pick<HeatingSchedulesByDayResponse, 'zone_id'>
      & { schedules?: Maybe<Array<Maybe<(
        { __typename?: 'DayHeatingSchedules' }
        & Pick<DayHeatingSchedules, 'end' | 'start' | 'temperature'>
      )>>> }
    )>> }
  )> }
);

export type GetWeeklyHeatingScheduleByZoneQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
}>;


export type GetWeeklyHeatingScheduleByZoneQuery = (
  { __typename?: 'Query' }
  & { getWeeklyHeatingScheduleByZone?: Maybe<(
    { __typename?: 'WeeklyHeatingScheduleResponse' }
    & { friday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>>, monday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>>, saturday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>>, sunday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>>, thursday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>>, tuesday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>>, wednesday?: Maybe<Array<(
      { __typename?: 'HeatingSchedule' }
      & Pick<HeatingSchedule, 'zone_id'>
      & { setpoints?: Maybe<Array<Maybe<(
        { __typename?: 'HeatingSetpoint' }
        & Pick<HeatingSetpoint, 'temperature' | 'time' | 'type' | 'user_time'>
      )>>> }
    )>> }
  )> }
);

export type ListTrialsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTrialsQuery = (
  { __typename?: 'Query' }
  & { listTrials?: Maybe<(
    { __typename?: 'TrialSearchResponse' }
    & Pick<TrialSearchResponse, 'itemCount'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Trial' }
      & Pick<Trial, 'createdBy' | 'createdOn' | 'id' | 'meterableUnitId' | 'name' | 'updatedBy' | 'updatedOn'>
    )>>> }
  )> }
);

export type SearchBeeDataQueryVariables = Exact<{
  query?: Maybe<QueryBee>;
}>;


export type SearchBeeDataQuery = (
  { __typename?: 'Query' }
  & { searchBeeData?: Maybe<(
    { __typename?: 'BeeSearchDataResponse' }
    & Pick<BeeSearchDataResponse, 'arePeripheralsHealthy' | 'currentAppVersion' | 'hardwareVersion' | 'lastStatusUpdate' | 'latestAppVersion' | 'status' | 'uptime'>
    & { bee?: Maybe<(
      { __typename?: 'Bee' }
      & Pick<Bee, 'arePeripheralsHealthy' | 'createdOn' | 'currentAppVersion' | 'currentFirmwareVersion' | 'deviceId' | 'firmwareUpdateRequested' | 'firmwareUpdateVersion' | 'firmwareVersion' | 'hardwareVersion' | 'inActiveTrialEvent' | 'isHealthy' | 'isHeatSourceOn' | 'plot' | 'project' | 'routerId' | 'stateLastUpdated' | 'status' | 'stickerImage' | 'tags' | 'trialId' | 'updatedOn' | 'uprn'>
      & { physicalAddress?: Maybe<(
        { __typename?: 'PropertyAddress' }
        & Pick<PropertyAddress, 'addressEnteredManually' | 'addressLine1' | 'city' | 'postcode' | 'udprn'>
      )>, trial?: Maybe<(
        { __typename?: 'Trial' }
        & Pick<Trial, 'createdBy' | 'createdOn' | 'id' | 'meterableUnitId' | 'name' | 'updatedBy' | 'updatedOn'>
      )> }
    )>, config?: Maybe<(
      { __typename?: 'Configuration' }
      & { device_config?: Maybe<(
        { __typename?: 'BeeDeviceConfig' }
        & Pick<BeeDeviceConfig, 'location'>
        & { heating?: Maybe<(
          { __typename?: 'DeviceConfigHeating' }
          & { temperature?: Maybe<(
            { __typename?: 'DeviceConfigHeatingTemperature' }
            & Pick<DeviceConfigHeatingTemperature, 'lower' | 'upper'>
          )> }
        )>, hot_water_temperature?: Maybe<(
          { __typename?: 'DeviceConfigHotWaterTemperature' }
          & Pick<DeviceConfigHotWaterTemperature, 'off' | 'on'>
        )>, temperature?: Maybe<(
          { __typename?: 'DeviceConfigHeatingTemperature' }
          & Pick<DeviceConfigHeatingTemperature, 'lower' | 'upper'>
        )> }
      )>, devices?: Maybe<Array<Maybe<(
        { __typename?: 'InternalDeviceType' }
        & Pick<InternalDeviceType, 'name' | 'protocol'>
        & { fields?: Maybe<Array<Maybe<(
          { __typename?: 'ModbusDeviceFieldsType' }
          & Pick<ModbusDeviceFieldsType, 'access' | 'address' | 'factor' | 'format' | 'length' | 'name' | 'unit'>
        )>>> }
      ) | (
        { __typename?: 'MBusDeviceType' }
        & Pick<MBusDeviceType, 'name' | 'protocol'>
      ) | (
        { __typename?: 'MasterthermDeviceType' }
        & Pick<MasterthermDeviceType, 'name' | 'protocol'>
        & { fields?: Maybe<Array<Maybe<(
          { __typename?: 'MasterthermDeviceFieldsType' }
          & Pick<MasterthermDeviceFieldsType, 'compressor_off_time' | 'temperature'>
        )>>> }
      ) | (
        { __typename?: 'ModBusDeviceType' }
        & Pick<ModBusDeviceType, 'name' | 'protocol'>
        & { fields?: Maybe<Array<Maybe<(
          { __typename?: 'ModbusDeviceFieldsType' }
          & Pick<ModbusDeviceFieldsType, 'access' | 'address' | 'factor' | 'format' | 'length' | 'name' | 'unit'>
        )>>> }
      ) | (
        { __typename?: 'RelayDeviceType' }
        & Pick<RelayDeviceType, 'name' | 'protocol'>
      )>>>, metadata?: Maybe<(
        { __typename?: 'ConfigurationMetadata' }
        & Pick<ConfigurationMetadata, 'beeMode' | 'configProfileVersion'>
      )>, rules?: Maybe<Array<Maybe<(
        { __typename?: 'BeeConfigurationRule' }
        & Pick<BeeConfigurationRule, 'name'>
        & { inputs?: Maybe<(
          { __typename?: 'BeeConfigurationRuleInput' }
          & Pick<BeeConfigurationRuleInput, 'address' | 'device_type' | 'hot_water_source_type' | 'primary_zone_temperature_sensor' | 'zone_id'>
          & { channel?: Maybe<(
            { __typename?: 'DeviceChannelForTCPConnection' }
            & Pick<DeviceChannelForTcpConnection, 'address' | 'port'>
          )>, metadata?: Maybe<(
            { __typename?: 'BeeConfigurationRuleInputMetadata' }
            & Pick<BeeConfigurationRuleInputMetadata, 'circuit_type' | 'clamp_1_circuit_type' | 'clamp_2_circuit_type' | 'clamp_3_circuit_type'>
          )> }
        )>, metadata?: Maybe<(
          { __typename?: 'BeeConfigurationRuleMetadata' }
          & Pick<BeeConfigurationRuleMetadata, 'action_type' | 'category' | 'circuit_label' | 'clamp_1_circuit_label' | 'clamp_2_circuit_label' | 'clamp_3_circuit_label' | 'dip_switch_position' | 'heat_flow_meter_circuit' | 'heat_pump_heating_control' | 'heating_system' | 'install_location' | 'meter_amperage' | 'non_metered_circuits' | 'variant'>
        )> }
      )>>> }
    )>, peripheralHealthChecks?: Maybe<Array<Maybe<(
      { __typename?: 'PeripheralHealthCheckType' }
      & Pick<PeripheralHealthCheckType, 'data' | 'device_type' | 'reason' | 'status' | 'timestamp' | 'zone_id'>
      & { datapoint_checks?: Maybe<Array<Maybe<(
        { __typename?: 'DataPointCommissioningCheckType' }
        & Pick<DataPointCommissioningCheckType, 'name' | 'status' | 'unit' | 'value'>
      )>>> }
    )>>> }
  )> }
);

export type SearchBeesQueryVariables = Exact<{
  query?: Maybe<QueryBee>;
}>;


export type SearchBeesQuery = (
  { __typename?: 'Query' }
  & { searchBees?: Maybe<(
    { __typename?: 'BeeSearchResponse' }
    & Pick<BeeSearchResponse, 'itemCount'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Bee' }
      & Pick<Bee, 'arePeripheralsHealthy' | 'createdOn' | 'currentAppVersion' | 'currentFirmwareVersion' | 'deviceId' | 'firmwareUpdateRequested' | 'firmwareUpdateVersion' | 'firmwareVersion' | 'hardwareVersion' | 'inActiveTrialEvent' | 'isHealthy' | 'isHeatSourceOn' | 'plot' | 'project' | 'routerId' | 'stateLastUpdated' | 'status' | 'stickerImage' | 'tags' | 'trialId' | 'updatedOn' | 'uprn'>
      & { physicalAddress?: Maybe<(
        { __typename?: 'PropertyAddress' }
        & Pick<PropertyAddress, 'addressEnteredManually' | 'addressLine1' | 'city' | 'postcode' | 'udprn'>
      )>, trial?: Maybe<(
        { __typename?: 'Trial' }
        & Pick<Trial, 'createdBy' | 'createdOn' | 'id' | 'meterableUnitId' | 'name' | 'updatedBy' | 'updatedOn'>
      )> }
    )>>> }
  )> }
);

export type SearchZonesQueryVariables = Exact<{
  deviceId?: Maybe<Scalars['String']>;
}>;


export type SearchZonesQuery = (
  { __typename?: 'Query' }
  & { searchZones?: Maybe<(
    { __typename?: 'ZoneSearchResponse' }
    & Pick<ZoneSearchResponse, 'itemCount'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Zone' }
      & Pick<Zone, 'description' | 'heating_state' | 'lower_bounds' | 'setpoint' | 'temperature' | 'upper_bounds' | 'zone_id'>
    )>>> }
  )> }
);


export const CreateHotWaterSchedules = gql`
    mutation createHotWaterSchedules($deviceId: ID, $hotWaterSchedules: WeeklyHotWaterScheduleInputs) {
  createHotWaterSchedules(
    deviceId: $deviceId
    hotWaterSchedules: $hotWaterSchedules
  ) {
    errorMessage
    success
  }
}
    `;
export const CreateTrial = gql`
    mutation createTrial($createInput: CreateTrial) {
  createTrial(createInput: $createInput) {
    id
    meterableUnitId
    name
  }
}
    `;
export const CreateWeeklyHeatingSchedule = gql`
    mutation createWeeklyHeatingSchedule($deviceId: ID, $heatingSchedule: WeeklyHeatingScheduleInputs) {
  createWeeklyHeatingSchedule(
    deviceId: $deviceId
    heatingSchedule: $heatingSchedule
  ) {
    errorMessage
    heatingSchedule {
      friday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      monday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      saturday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      sunday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      thursday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      tuesday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
      wednesday {
        setpoints {
          temperature
          time
          type
          user_time
        }
        zone_id
      }
    }
    success
  }
}
    `;
export const DeleteTrial = gql`
    mutation deleteTrial($deleteInput: DeleteTrial) {
  deleteTrial(deleteInput: $deleteInput) {
    affected
  }
}
    `;
export const EditEquinoxTrial = gql`
    mutation editEquinoxTrial($deviceId: String, $flag: Boolean) {
  editEquinoxTrial(deviceId: $deviceId, flag: $flag) {
    errorMessage
    success
  }
}
    `;
export const OverrideHeating = gql`
    mutation overrideHeating($beeId: ID, $setpoint: Float, $zoneId: ID) {
  overrideHeating(beeId: $beeId, setpoint: $setpoint, zoneId: $zoneId) {
    error_message
    success
  }
}
    `;
export const OverrideHotWater = gql`
    mutation overrideHotWater($deviceId: ID, $status: String) {
  overrideHotWater(deviceId: $deviceId, status: $status) {
    error_message
    success
  }
}
    `;
export const SendPeripheralCommand = gql`
    mutation sendPeripheralCommand($deviceId: String, $deviceType: String, $requestedState: Float) {
  sendPeripheralCommand(
    deviceId: $deviceId
    deviceType: $deviceType
    requestedState: $requestedState
  ) {
    errorMessage
    success
  }
}
    `;
export const UpdateBee = gql`
    mutation updateBee($bee: UpdateBee) {
  updateBee(bee: $bee) {
    arePeripheralsHealthy
    bee {
      arePeripheralsHealthy
      createdOn
      currentAppVersion
      currentFirmwareVersion
      deviceId
      firmwareUpdateRequested
      firmwareUpdateVersion
      firmwareVersion
      hardwareVersion
      inActiveTrialEvent
      isHealthy
      isHeatSourceOn
      physicalAddress {
        addressEnteredManually
        addressLine1
        city
        postcode
        udprn
      }
      plot
      project
      routerId
      stateLastUpdated
      status
      stickerImage
      tags
      trial {
        createdBy
        createdOn
        id
        meterableUnitId
        name
        updatedBy
        updatedOn
      }
      trialId
      updatedOn
      uprn
    }
    config {
      device_config {
        heating {
          temperature {
            lower
            upper
          }
        }
        hot_water_temperature {
          off
          on
        }
        location
        temperature {
          lower
          upper
        }
      }
      devices {
        ... on InternalDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on MBusDeviceType {
          name
          protocol
        }
        ... on MasterthermDeviceType {
          fields {
            compressor_off_time
            temperature
          }
          name
          protocol
        }
        ... on ModBusDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on RelayDeviceType {
          name
          protocol
        }
      }
      metadata {
        beeMode
        configProfileVersion
      }
      rules {
        inputs {
          address
          channel {
            address
            port
          }
          device_type
          hot_water_source_type
          metadata {
            circuit_type
            clamp_1_circuit_type
            clamp_2_circuit_type
            clamp_3_circuit_type
          }
          primary_zone_temperature_sensor
          zone_id
        }
        metadata {
          action_type
          category
          circuit_label
          clamp_1_circuit_label
          clamp_2_circuit_label
          clamp_3_circuit_label
          dip_switch_position
          heat_flow_meter_circuit
          heat_pump_heating_control
          heating_system
          install_location
          meter_amperage
          non_metered_circuits
          variant
        }
        name
      }
    }
    currentAppVersion
    hardwareVersion
    lastStatusUpdate
    latestAppVersion
    peripheralHealthChecks {
      data
      datapoint_checks {
        name
        status
        unit
        value
      }
      device_type
      reason
      status
      timestamp
      zone_id
    }
    status
    uptime
  }
}
    `;
export const UpgradeFirmware = gql`
    mutation upgradeFirmware($upgradeFirmware: UpgradeFirmwareRequest) {
  upgradeFirmware(upgradeFirmware: $upgradeFirmware) {
    url
  }
}
    `;
export const FirmwareVersions = gql`
    query firmwareVersions($deviceId: String, $hardwareVersion: String) {
  firmwareVersions(deviceId: $deviceId, hardwareVersion: $hardwareVersion) {
    firmwareVersions
  }
}
    `;
export const GetAvailableConfigs = gql`
    query getAvailableConfigs {
  getAvailableConfigs {
    availableConfigs {
      displayName
      originalFileName
    }
  }
}
    `;
export const GetBeeModes = gql`
    query getBeeModes {
  getBeeModes {
    beeModes
  }
}
    `;
export const GetBeeStatistics = gql`
    query getBeeStatistics($query: QueryBee) {
  getBeeStatistics(query: $query) {
    numberOfDevicesOffline
    numberOfDevicesOnline
    totalBees
    totalHealthcheckErrors
  }
}
    `;
export const GetConfigProfileVersions = gql`
    query getConfigProfileVersions {
  getConfigProfileVersions {
    configProfileVersions
  }
}
    `;
export const GetControlPeripherals = gql`
    query getControlPeripherals($deviceId: ID) {
  getControlPeripherals(deviceId: $deviceId) {
    peripherals {
      deviceCategory
      deviceType
      hasPermission
      state
    }
  }
}
    `;
export const GetFirmwareVersions = gql`
    query getFirmwareVersions {
  getFirmwareVersions {
    firmwareVersions
  }
}
    `;
export const GetHeatingInformation = gql`
    query getHeatingInformation($beeId: ID, $zoneId: ID) {
  getHeatingInformation(beeId: $beeId, zoneId: $zoneId) {
    heating_state
    lower_bounds
    setpoint
    temperature
    upper_bounds
  }
}
    `;
export const GetHotWaterInformation = gql`
    query getHotWaterInformation($deviceId: ID) {
  getHotWaterInformation(deviceId: $deviceId) {
    device_hot_water_active
    hot_water_active
    schedule_hot_water_active
    set_at {
      by
      day
      time
    }
  }
}
    `;
export const GetHotWaterSchedules = gql`
    query getHotWaterSchedules($deviceId: ID, $getNextSchedule: Boolean) {
  getHotWaterSchedules(deviceId: $deviceId, getNextSchedule: $getNextSchedule) {
    friday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    monday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    saturday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    sunday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    thursday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    tuesday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
    wednesday {
      setpoints {
        hot_water_active
        time
        user_time
      }
      zone_id
    }
  }
}
    `;
export const GetHotWaterSources = gql`
    query getHotWaterSources {
  getHotWaterSources {
    hotWaterSources
  }
}
    `;
export const GetWeeklyHeatingSchedule = gql`
    query getWeeklyHeatingSchedule($deviceId: ID) {
  getWeeklyHeatingSchedule(deviceId: $deviceId) {
    friday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    monday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    saturday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    sunday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    thursday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    tuesday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
    wednesday {
      schedules {
        end
        start
        temperature
      }
      zone_id
    }
  }
}
    `;
export const GetWeeklyHeatingScheduleByZone = gql`
    query getWeeklyHeatingScheduleByZone($deviceId: ID, $zoneId: ID) {
  getWeeklyHeatingScheduleByZone(deviceId: $deviceId, zoneId: $zoneId) {
    friday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    monday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    saturday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    sunday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    thursday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    tuesday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
    wednesday {
      setpoints {
        temperature
        time
        type
        user_time
      }
      zone_id
    }
  }
}
    `;
export const ListTrials = gql`
    query listTrials {
  listTrials {
    itemCount
    items {
      createdBy
      createdOn
      id
      meterableUnitId
      name
      updatedBy
      updatedOn
    }
  }
}
    `;
export const SearchBeeData = gql`
    query searchBeeData($query: QueryBee) {
  searchBeeData(query: $query) {
    arePeripheralsHealthy
    bee {
      arePeripheralsHealthy
      createdOn
      currentAppVersion
      currentFirmwareVersion
      deviceId
      firmwareUpdateRequested
      firmwareUpdateVersion
      firmwareVersion
      hardwareVersion
      inActiveTrialEvent
      isHealthy
      isHeatSourceOn
      physicalAddress {
        addressEnteredManually
        addressLine1
        city
        postcode
        udprn
      }
      plot
      project
      routerId
      stateLastUpdated
      status
      stickerImage
      tags
      trial {
        createdBy
        createdOn
        id
        meterableUnitId
        name
        updatedBy
        updatedOn
      }
      trialId
      updatedOn
      uprn
    }
    config {
      device_config {
        heating {
          temperature {
            lower
            upper
          }
        }
        hot_water_temperature {
          off
          on
        }
        location
        temperature {
          lower
          upper
        }
      }
      devices {
        ... on InternalDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on MBusDeviceType {
          name
          protocol
        }
        ... on MasterthermDeviceType {
          fields {
            compressor_off_time
            temperature
          }
          name
          protocol
        }
        ... on ModBusDeviceType {
          fields {
            access
            address
            factor
            format
            length
            name
            unit
          }
          name
          protocol
        }
        ... on RelayDeviceType {
          name
          protocol
        }
      }
      metadata {
        beeMode
        configProfileVersion
      }
      rules {
        inputs {
          address
          channel {
            address
            port
          }
          device_type
          hot_water_source_type
          metadata {
            circuit_type
            clamp_1_circuit_type
            clamp_2_circuit_type
            clamp_3_circuit_type
          }
          primary_zone_temperature_sensor
          zone_id
        }
        metadata {
          action_type
          category
          circuit_label
          clamp_1_circuit_label
          clamp_2_circuit_label
          clamp_3_circuit_label
          dip_switch_position
          heat_flow_meter_circuit
          heat_pump_heating_control
          heating_system
          install_location
          meter_amperage
          non_metered_circuits
          variant
        }
        name
      }
    }
    currentAppVersion
    hardwareVersion
    lastStatusUpdate
    latestAppVersion
    peripheralHealthChecks {
      data
      datapoint_checks {
        name
        status
        unit
        value
      }
      device_type
      reason
      status
      timestamp
      zone_id
    }
    status
    uptime
  }
}
    `;
export const SearchBees = gql`
    query searchBees($query: QueryBee) {
  searchBees(query: $query) {
    itemCount
    items {
      arePeripheralsHealthy
      createdOn
      currentAppVersion
      currentFirmwareVersion
      deviceId
      firmwareUpdateRequested
      firmwareUpdateVersion
      firmwareVersion
      hardwareVersion
      inActiveTrialEvent
      isHealthy
      isHeatSourceOn
      physicalAddress {
        addressEnteredManually
        addressLine1
        city
        postcode
        udprn
      }
      plot
      project
      routerId
      stateLastUpdated
      status
      stickerImage
      tags
      trial {
        createdBy
        createdOn
        id
        meterableUnitId
        name
        updatedBy
        updatedOn
      }
      trialId
      updatedOn
      uprn
    }
  }
}
    `;
export const SearchZones = gql`
    query searchZones($deviceId: String) {
  searchZones(deviceId: $deviceId) {
    itemCount
    items {
      description
      heating_state
      lower_bounds
      setpoint
      temperature
      upper_bounds
      zone_id
    }
  }
}
    `;